module.exports = __webpack_public_path__ + "static/media/DinningArea-f.92853636.webp";